var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "createCampaign",
    attrs: {
      id: "create-campaign-modal",
      "modal-dialog-size": "xs",
      "modal-dialog-scrollable": false,
      "footer-close-button-text": _vm.$t("global.actions.editInformation"),
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c(
              "h5",
              { staticClass: "modal-title", attrs: { id: "modal-title" } },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t(
                        _vm.create
                          ? "campaigns.actions.createACampaign"
                          : "campaigns.actions.editACampaign"
                      )
                    ) +
                    "\n    "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("p", [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("campaigns.messages.campaignWillBeSentOn")) +
                  "\n      "
              ),
              _c("span", { staticClass: "bold" }, [
                _vm._v(" " + _vm._s(_vm._f("formatDateHour")(_vm.date)) + " "),
              ]),
              _vm._v("\n      (\n      "),
              _c("span", { staticClass: "text-uppercase small" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm._f("formatTimeAgo")(_vm.date)) +
                    "\n      "
                ),
              ]),
              _vm._v("\n      )\n    "),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "small bold" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("campaigns.messages.sentCampaignNote")) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _vm.isPastDate
              ? _c("p", { staticClass: "small text-danger" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("campaigns.messages.dateInPast")) +
                      "\n    "
                  ),
                ])
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "simple-button",
              {
                attrs: {
                  disabled: _vm.isPastDate,
                  loading: _vm.saving,
                  "loading-succeeded": _vm.savingSucceeded,
                },
                on: { click: _vm.handleSubmit, finish: _vm.closeModal },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t(
                        _vm.create
                          ? "campaigns.actions.createCampaign"
                          : "campaigns.actions.editCampaign"
                      )
                    ) +
                    "\n    "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }